import React from 'react';


const AccountStatsPanel = ({ accounts = [] }) => {
  const planCounts = accounts?.reduce((acc, a) => {
    const plan = a?.plan?.toLowerCase() || 'free';
    acc[plan] = (acc?.[plan] || 0) + 1;
    return acc;
  }, {});

  const statusCounts = accounts?.reduce((acc, a) => {
    const status = a?.status?.toLowerCase() || 'active';
    acc[status] = (acc?.[status] || 0) + 1;
    return acc;
  }, {});

  const total = accounts?.length || 0;
  const active = statusCounts?.active || 0;
  const inactive = (statusCounts?.inactive || 0) + (statusCounts?.suspended || 0);
  const activeRate = total > 0 ? Math.round((active / total) * 100) : 0;

  const planItems = [
    { label: 'Free', count: planCounts?.free || 0, color: 'bg-gray-400', textColor: 'text-gray-600' },
    { label: 'Professional', count: planCounts?.professional || 0, color: 'bg-blue-500', textColor: 'text-blue-600' },
    { label: 'Enterprise', count: planCounts?.enterprise || 0, color: 'bg-purple-500', textColor: 'text-purple-600' },
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-5">
      <h2 className="text-base font-heading font-semibold text-foreground mb-4">Account Breakdown</h2>

      {/* Active vs Inactive */}
      <div className="mb-5">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm text-muted-foreground">Active Rate</span>
          <span className="text-sm font-semibold text-foreground">{activeRate}%</span>
        </div>
        <div className="h-2.5 bg-muted rounded-full overflow-hidden flex">
          <div
            className="h-full bg-green-500 rounded-l-full transition-all"
            style={{ width: `${activeRate}%` }}
          />
          <div
            className="h-full bg-gray-300 rounded-r-full transition-all"
            style={{ width: `${100 - activeRate}%` }}
          />
        </div>
        <div className="flex items-center justify-between mt-2">
          <div className="flex items-center gap-1.5">
            <div className="w-2 h-2 rounded-full bg-green-500" />
            <span className="text-xs text-muted-foreground">{active} active</span>
          </div>
          <div className="flex items-center gap-1.5">
            <div className="w-2 h-2 rounded-full bg-gray-300" />
            <span className="text-xs text-muted-foreground">{inactive} inactive</span>
          </div>
        </div>
      </div>

      {/* Plan Distribution */}
      <div>
        <p className="text-sm font-medium text-foreground mb-3">By Plan</p>
        <div className="space-y-2.5">
          {planItems?.map((item) => (
            <div key={item?.label} className="flex items-center gap-3">
              <div className={`w-2.5 h-2.5 rounded-full flex-shrink-0 ${item?.color}`} />
              <div className="flex-1">
                <div className="flex items-center justify-between mb-1">
                  <span className="text-sm text-foreground">{item?.label}</span>
                  <span className={`text-sm font-semibold ${item?.textColor}`}>{item?.count}</span>
                </div>
                <div className="h-1.5 bg-muted rounded-full overflow-hidden">
                  <div
                    className={`h-full rounded-full ${item?.color} transition-all`}
                    style={{ width: total > 0 ? `${(item?.count / total) * 100}%` : '0%' }}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Quick Stats */}
      <div className="mt-5 pt-4 border-t border-border grid grid-cols-2 gap-3">
        <div className="text-center">
          <p className="text-xl font-bold text-foreground">{total}</p>
          <p className="text-xs text-muted-foreground">Total Accounts</p>
        </div>
        <div className="text-center">
          <p className="text-xl font-bold text-green-600">{active}</p>
          <p className="text-xs text-muted-foreground">Active Now</p>
        </div>
      </div>
    </div>
  );
};

export default AccountStatsPanel;
